import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from "react";
import { Box } from "@mui/material";
import { evaluateElementConditions, interpolateDynamicText, } from "../../../../utils/elements-condition";
import { useFormLogic } from "../../context/FormLogicContext";
import { sanitizeFormHtml } from "../../utils/html-sanitizer";
var HtmlField = function (_a) {
    var element = _a.element;
    var _b = useFormLogic(), formValues = _b.formValues, elementsTypeInfoByName = _b.elementsTypeInfoByName, pageEnabledFallback = _b.pageEnabledFallback;
    var isVisible = useMemo(function () {
        return evaluateElementConditions(element, formValues, elementsTypeInfoByName, pageEnabledFallback);
    }, [element, formValues, elementsTypeInfoByName, pageEnabledFallback]).isVisible;
    var sanitizedHtml = useMemo(function () {
        var _a;
        var processedHtml = interpolateDynamicText((_a = element.html) !== null && _a !== void 0 ? _a : "", formValues);
        return sanitizeFormHtml(processedHtml);
    }, [element.html, formValues]);
    if (!isVisible)
        return null;
    return (_jsx(Box, { className: "component-wrapper", "data-testid": "html-field-".concat(element.name), sx: {
            "& img": {
                display: "block",
                height: "auto",
                maxWidth: "100%",
            },
        }, dangerouslySetInnerHTML: { __html: sanitizedHtml } }));
};
export default HtmlField;
